var render = function render(){var _vm=this,_c=_vm._self._c;return _c('content-editor',{attrs:{"permission":"page","fields":_vm.fields,"publication":true,"hasAuthor":false,"previewModule":"page","endpoint":"page","module":"page"},on:{"update":_vm.updateState}})
}
var staticRenderFns = []

export { render, staticRenderFns }